import axios from '@/fetch/index';
import config from '@/fetch/config/index';
const { get, post, post2 } = axios;
const { relApi, LogUrl } = config;

const customerService = `${relApi}/ai-customer-service`;
const LogService = `${LogUrl}/ai-customer-service`;

/* 访客 */
//创建客户端访客用户
export function createVisitorAccount(params) {
  // return axios({
  //   url: `${customerService}/cs/visitor/account/create`,
  //   method: 'post',
  //   data: params,
  //   headers: {
  //     'Accept': 'application/json',
  //     'Content-Type': 'application/json; charset=UTF-8'
  //   }
  // })
  return post2(`${customerService}/cs/visitor/account/create`, params);
}

//获取访客账号信息
export function getAccountInfo(params) {
  // return axios({
  //   url: `${customerService}/cs/visitor/account/create`,
  //   method: 'post',
  //   data: params,
  //   headers: {
  //     'Accept': 'application/json',
  //     'Content-Type': 'application/json; charset=UTF-8'
  //   }
  // })
  return post2(`${customerService}/cs/visitor/account/info`, params);
}


//获取访客账号信息
export function getAccountInfoUrl() {
  // return axios({
  //   url: `${customerService}/cs/visitor/account/create`,
  //   method: 'post',
  //   data: params,
  //   headers: {
  //     'Accept': 'application/json',
  //     'Content-Type': 'application/json; charset=UTF-8'
  //   }
  // })
  return `${customerService}/cs/visitor/account/info`;
}


export function isExChannelOnline(params) {
  return get(`${relApi}/ai-customer-service/cs/visitor/in-black-list/${params.companyId}/${params.childChannelId}/${params.visitSign}`);
}

//根据配置为用户分配相应的客服人员
export function selectCustomerService(params) {
  return post2(`${customerService}/cs/visitor/select/${params.childChannelId}`, params);
}

//更新用户信息
export function updateCardField(params) {
  return post(`${customerService}/cs/visitor/updateField/${params.type}?conversationId=${params.conversationId}`, params.cardPropertyValueReqList);
}

//根据配置为访客分配相应的客服人员（邀请类型调用）
export function inviteVisitor(params) {
  return post(`${customerService}/cs/visitor/confirm/conversation/${params.userId}/${params.visitSign}`, params);
}

/* 留言 */
// 查询渠道下的留言模板
export function getChannelMessageTemplate(params) {
  return post(`${customerService}/cs/visitor/selectChannelTemplate`, params);
}

// 保存留言信息
export function saveMessageInfo(params) {
  return post(`${customerService}/cs/visitor/save`, params);
}

// 保存留言信息
export function saveVisitorInfo(params) {
  return post(`${customerService}/cs/visitor/saveVisitInfoConversation`, params);
}

export function saveCollectVisitorInfo(params) {
  return post(`${customerService}/cs/visitor/collectVisitorInfo`, params);
}


// 收集报错信息
export function saveCollectErrorMessage(params) {
  return post(`${customerService}/collect/client/error/message`, params);
}

// 测试TaskFlow流程
export function csVisitorTestTaskFlow(params) {
  return post(`${customerService}/cs/visitor/test/taskFlow`, params);
}

//客服结束会话
export function finishConversation(params) {
  return post2(`${customerService}/conversation/client/finish`, params );
}
// 加载执行过程信息上报日志
export function saveRequestLog(params) {
  return post(`${LogService}/request/log`, params);
  // return get('https://kf.yunduocrm.com/api/ai-customer-service/request/log', params)
}
//
export function updateEnumField(params) {
  return post(`${customerService}/cs/visitor/update/enum/field`, params);
}
// 提交表单卡片信息
export function updateFormCard(params) {
  return post(`${customerService}/cs/visitor/form`, params);
}
// 获取表单信息
export function getFormDataList(cardId, params) {
  return post(`${customerService}/conversationForm/getFormDataList/${cardId}`, params);
}
//
export function apiAddWechat(conversationId, type) {
  return get(`${customerService}/cs/visitor/addWechatFlag/${conversationId}/${type}`, {});
}
export function apiGetWxReg(params) {
  return post(`${customerService}/cs/visitor/getWxRegDiction/${params.companyId}`);
}

export function apiMessageNotice(params) {
  return post(`${customerService}/cs/visitor/human/messageNotice/`, params);
}
export function apiUpdateSiteId(conversationId, siteId) {
  return post(`${customerService}/cs/visitor/updateSiteId/${conversationId}/${siteId}`, params);
}

export function apiSendEvent(params) {
  return post(`${customerService}/cs/visitor/savePageOper`, params);
}

// 批量获取客服信息（用于getUsers查询）
export function getUsersBatchInfo(params) {
  return post2(`${customerService}/cs/visitor/getUsersBatchInfo`, params);
}

// 批量获取客服信息（用于getUsers查询）
export function getChatMessages(params) {
  return post2(`${customerService}/cs/visitor/getChatMessages`, params);
}



// WEBPACK FOOTER //
// ./src/services/chat.js